<div>
    <app-piechart [setOptions]="null" [value]="null">
    </app-piechart>
    <div class="centered">
        {{'Keine aktuellen Daten vorhanden'}}
    </div>
</div>
